import type { ApiPostRaceComments, PostRaceComments } from '@api/types/postRaceComments';

const adaptPostRaceComments = (data: ApiPostRaceComments): PostRaceComments => {
  return {
    raceAnalysis: data.raceAnalysis ?? null,
    runnersComments: (data.runnersComments ?? []).map((comment) => ({
      runnerNumber: comment.runnerNumber ?? null,
      comment: comment.comment ?? null,
    })),
  };
};

export { adaptPostRaceComments };
